module.exports = __webpack_public_path__ + "img/accessories_banner.24c364a6.png";